function illustroCartOptionsGetSettings() {
  var settingsScript = document.getElementById('IllustroCartOptionsSettings');
  if (!settingsScript) return {};

  try {
    return JSON.parse(settingsScript.textContent || '{}');
  } catch (error) {
    return {};
  }
}

function illustroCartOptionsEscapeAttribute(value) {
  return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function illustroCartOptionsImageHtml(url) {
  return '<img src="' + illustroCartOptionsEscapeAttribute(url) + '" alt="" class="illustro-cart-options-row__custom-icon" aria-hidden="true">';
}

function illustroCartOptionsInit() {
  document.querySelectorAll('.cart-drawer-subtotal:not([data-illustro-cart-options])').forEach(function(subtotal) {
    var giftWrap = subtotal.querySelector('#is-a-gift');
    if (!giftWrap) return;

    var accordion = giftWrap.closest('accordeon-component');
    var giftContent = subtotal.querySelector('.cart-drawer-subtotal__note');
    if (!accordion || !giftContent) return;

    subtotal.setAttribute('data-illustro-cart-options', 'true');
    var footer = subtotal.closest('cart-drawer-footer');
    if (footer) footer.setAttribute('data-illustro-cart-options-footer', 'true');

    var optionsSettings = illustroCartOptionsGetSettings();
    var accordionButton = accordion.querySelector('accordeon-button');
    var giftTitle = accordionButton ? accordionButton.textContent.trim() : 'Is this a gift?';
    var giftIcon = accordionButton ? accordionButton.querySelector('img') : null;
    var giftIconHtml = optionsSettings.giftIconUrl ? illustroCartOptionsImageHtml(optionsSettings.giftIconUrl) : giftIcon ? giftIcon.outerHTML : '';
    var discountTitle = document.documentElement.lang === 'tr' ? 'İndirim kodu' : 'Discount code';
    var discountPlaceholder = document.documentElement.lang === 'tr' ? 'İndirim kodu ekle' : 'Add discount code';
    var applyText = document.documentElement.lang === 'tr' ? 'Uygula' : 'Apply';
    var discountIconText = optionsSettings.discountIconText || '%';
    var discountIconHtml = optionsSettings.discountIconUrl ? illustroCartOptionsImageHtml(optionsSettings.discountIconUrl) : '<span class="illustro-cart-options-row__discount-icon">' + illustroCartOptionsEscapeAttribute(discountIconText) + '</span>';

    var row = document.createElement('div');
    row.className = 'illustro-cart-options-row';
    row.innerHTML = '<button type="button" class="illustro-cart-options-row__button" data-illustro-cart-options-open="gift">' + giftIconHtml + '<span>' + giftTitle + '</span></button><div class="illustro-cart-options-row__divider"></div><button type="button" class="illustro-cart-options-row__button" data-illustro-cart-options-open="discount">' + discountIconHtml + '<span>' + discountTitle + '</span></button>';

    var giftSheet = document.createElement('div');
    giftSheet.className = 'illustro-cart-options-sheet';
    giftSheet.setAttribute('data-illustro-cart-options-sheet', 'gift');
    giftSheet.setAttribute('aria-hidden', 'true');
    giftSheet.innerHTML = '<div class="illustro-cart-options-sheet__overlay" data-illustro-cart-options-close></div><div class="illustro-cart-options-sheet__panel" role="dialog" aria-modal="true"><button type="button" class="illustro-cart-options-sheet__close" data-illustro-cart-options-close aria-label="Close">×</button><div class="illustro-cart-options-sheet__title"></div><div class="illustro-cart-options-sheet__body"></div></div>';
    giftSheet.querySelector('.illustro-cart-options-sheet__title').textContent = giftTitle;
    giftSheet.querySelector('.illustro-cart-options-sheet__body').appendChild(giftContent);

    var discountSheet = document.createElement('div');
    discountSheet.className = 'illustro-cart-options-sheet';
    discountSheet.setAttribute('data-illustro-cart-options-sheet', 'discount');
    discountSheet.setAttribute('aria-hidden', 'true');
    discountSheet.innerHTML = '<div class="illustro-cart-options-sheet__overlay" data-illustro-cart-options-close></div><div class="illustro-cart-options-sheet__panel" role="dialog" aria-modal="true"><button type="button" class="illustro-cart-options-sheet__close" data-illustro-cart-options-close aria-label="Close">×</button><div class="illustro-cart-options-sheet__title">' + discountTitle + '</div><div class="illustro-cart-options-sheet__body"><form class="illustro-cart-options-discount" data-illustro-cart-options-discount-form><input class="input input--large input--solid" type="text" placeholder="' + discountPlaceholder + '" data-illustro-cart-options-discount-input required><button type="submit" class="btn btn--solid btn--lg">' + applyText + '</button></form></div></div>';

    subtotal.insertBefore(row, accordion);
    subtotal.insertBefore(giftSheet, accordion);
    subtotal.insertBefore(discountSheet, accordion);
    accordion.style.display = 'none';

    row.querySelector('[data-illustro-cart-options-open="gift"]').addEventListener('click', function() {
      illustroCartOptionsOpen(giftSheet);
    });

    row.querySelector('[data-illustro-cart-options-open="discount"]').addEventListener('click', function() {
      illustroCartOptionsOpen(discountSheet);
    });

    discountSheet.querySelector('[data-illustro-cart-options-discount-form]').addEventListener('submit', function(event) {
      event.preventDefault();
      var input = discountSheet.querySelector('[data-illustro-cart-options-discount-input]');
      var code = input ? input.value.trim() : '';
      if (!code) return;
      window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search));
    });
  });
}

function illustroCartOptionsOpen(sheet) {
  sheet.classList.add('is-open');
  sheet.setAttribute('aria-hidden', 'false');
  document.documentElement.classList.add('illustro-cart-options-open');
}

function illustroCartOptionsClose(sheet) {
  sheet.classList.remove('is-open');
  sheet.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('illustro-cart-options-open');
}

document.addEventListener('click', function(event) {
  var closeButton = event.target.closest('[data-illustro-cart-options-close]');
  if (!closeButton) return;
  var sheet = closeButton.closest('[data-illustro-cart-options-sheet]');
  if (sheet) illustroCartOptionsClose(sheet);
});

document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-illustro-cart-options-sheet].is-open').forEach(function(sheet) {
    illustroCartOptionsClose(sheet);
  });
});

document.addEventListener('DOMContentLoaded', illustroCartOptionsInit);
document.addEventListener('cart:updated', illustroCartOptionsInit);
document.addEventListener('shopify:section:load', illustroCartOptionsInit);
window.addEventListener('load', illustroCartOptionsInit);

new MutationObserver(function() {
  illustroCartOptionsInit();
}).observe(document.documentElement, {
  childList: true,
  subtree: true
});

setTimeout(illustroCartOptionsInit, 400);
setTimeout(illustroCartOptionsInit, 1200);
setTimeout(illustroCartOptionsInit, 2500);
